import { z } from 'zod';

export const FloorPlansSchema = z.object({
    floorPlans: z.array(
        z.strictObject({
            id: z.string(),
            src: z.string(),
        }),
    ),
});
